import { useMyProfileQuery } from "../../../services/profileService/profile-api";
import { 
  hasAdminAccess,
  hasPermission,
  canEditTicket,
  hasViewAccess,
  TicketPermission
} from "../utils/permissionUtils";

/**
 * A custom hook that provides permission checking functions based on the user profile
 */
export const usePermissions = () => {
  const { data: userProfile, isLoading, error } = useMyProfileQuery();
  
  return {
    userProfile,
    isLoading,
    error,
    isAdmin: hasAdminAccess(userProfile),
    hasViewAccess: hasViewAccess(userProfile),
    
    // Methods that can be called with specific parameters
    hasPermission: (permission: TicketPermission | string) => 
      hasPermission(userProfile, permission),
    
    canEditTicket: (ticket: any) => 
      canEditTicket(userProfile, ticket),
      
    // Method to check if user is in a specific role
    hasRole: (role: string) => 
      userProfile?.role === role,
  };
};
